import { Box, Pagination, Text } from '@freenow/wave';
import React from 'react';

interface RemotePaginationProps {
    index: number;
    onIndexChange: (newIndex: number) => void;
    totalElements: number;
    totalPages: number;
    pageSize: number;
}

export const RemotePagination = ({
    index,
    onIndexChange,
    totalElements,
    totalPages,
    pageSize,
}: RemotePaginationProps) => {
    if (totalPages <= 1) {
        return null;
    }

    return (
        <Box mt={4}>
            <Pagination
                value={index + 1}
                pageSize={pageSize}
                totalItems={totalElements}
                onNextPage={() => onIndexChange(index + 1)}
                onPrevPage={() => onIndexChange(index - 1)}
                onSkipForward={() => onIndexChange(totalPages - 1)}
                onSkipBackward={() => onIndexChange(0)}
                label={
                    <Text as="b" fontWeight="semibold" secondary>
                        {index + 1} / {totalPages}
                    </Text>
                }
            />
        </Box>
    );
};
